import { SAVE_SELECTED_TIRE_OBJECT } from "../tire_action/tiresActions"

import { saveState, loadState } from "../../utilities/sessionStorage"

const defaultState = {
  vehicle: null,
  selectedRim: null,
  tireDetails: null,
  selectedShop: null,
  filters: {},
  tireDetailsObject: null,
  orderDetails: null,
  tireQuantity: null,
  date: null,
  time: null
}

export const initialState = loadState("tireState") || defaultState

export default function (state = initialState, action) {
  const { payload, type } = action
  let newState

  switch (type) {
    case "TIRES_SET_VEHICLE":
      newState = { ...state, vehicle: payload.vehicle }
      break

    case "TIRES_SET_RIM":
      newState = { ...state, selectedRim: payload.rim }
      break

    case "TIRES_SET_FILTERS":
      newState = { ...state, filters: payload.filters }
      break

    case SAVE_SELECTED_TIRE_OBJECT:
      newState = { ...state, tireDetailsObject: payload }
      break

    case "TIRES_SET_SHOP":
      newState = { ...state, selectedShop: payload.shop }
      break

    case "TIRES_SET_ORDER_DETAILS":
      newState = { ...state, orderDetails: payload.orderDetails }
      break

    case "TIRES_SET_INSTALLATION_DATE_TIME":
      newState = { ...state, date: payload.date, time: payload.time }
      break

    case "TIRE_CART_ITEM":
      newState = {
        ...state,
        tireDetails: payload.cartTireObject,
        tireQuantity: payload.tireQuantity
      }
      break

    default:
      return state
  }

  saveState("tireState", newState)
  return newState
}
